module.exports = __webpack_public_path__ + "img/logo.34b0c333.png";